import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

import { assertDevelopmentBuild, DevPreviewUnavailable } from '@/spa/dev-only'

// The ternary is folded by Rollup in a production build, so the preview chunk
// is never emitted. See DevPreviewUnavailable in @/spa/dev-only.
const component = import.meta.env.DEV
  ? lazy(() =>
      import('@/features/services/ui/customer/dev-services-preview').then((m) => ({ default: m.ServicesDevPreview })),
    )
  : DevPreviewUnavailable

export const Route = createFileRoute('/_bare/dev/services-preview')({
  beforeLoad: assertDevelopmentBuild,
  component,
})
